'use strict';
import { createAction } from 'redux-actions';

const ROUTE_CHANGE = 'ROUTE_CHANGE';

export const routeChange = createAction(ROUTE_CHANGE);
